export const wagonNumberValidationRegex = /^[#0-9][(0-9|\s|\-)]*$/
